import { DrawingAction, ActionNames } from '../actions/DrawingAction';
import { PictureStorageState, createLivePictureItem } from './pictureStorage';

export function reducePictureStorageByDrawingAction(
  state: PictureStorageState<HTMLCanvasElement>,
  action: DrawingAction,
): PictureStorageState<HTMLCanvasElement> {
  switch (action.type) {
    case ActionNames.REPLACE_HANDWRITING_TILES: {
      if (action.tiles.isEmpty) {
        return state;
      }

      let modified = false;
      const items = { ...state.items };
      action.tiles.forEach((_row, _column, entry) => {
        const { id, picture } = entry;
        items[id] = createLivePictureItem(state, id, picture);
        if (state.items[id] !== items[id]) {
          modified = true;
        }
      });

      return modified ? { ...state, items } : state;
    }

    case ActionNames.PASTE_IMAGE: {
      const { id, picture } = action.source;
      const items = { ...state.items };
      items[id] = createLivePictureItem(state, id, picture);
      return state.items[id] === items[id] ? state : { ...state, items };
    }

    default:
      return state;
  }
}
